function o(e) {
  typeof e.remove < "u" ? e.remove() : typeof e.parentNode < "u" && e.parentNode !== null && e.parentNode.removeChild(e);
}
function r(e) {
  const t = document.createElement("div");
  t.style.position = "absolute", t.style.left = "0px", t.style.top = "0px", t.style.width = "100%";
  const n = document.createElement("div");
  return t.appendChild(n), n.appendChild(e), document.body.appendChild(t), t;
}
function d(e) {
  return e === void 0 ? null : isNaN(e) ? e : e + "px";
}
function l(e) {
  return e.closest(".dropdown-item_custom") !== null;
}
export {
  r as createAbsoluteElement,
  l as isCustomElement,
  o as removeElement,
  d as toCssWidth
};
